import type { Subscriptions } from '@rails/actioncable';
import { useEffect, useRef } from 'react';
import { useActionCable } from '~/providers';

type UseActionCableSubscriptionOptions = {
  isEnabled?: boolean;
};

/**
 * Handles the lifecycle of an ActionCable subscription.
 * By default, subscriptions are created on mount.
 * Disable this behavior by setting `options.isEnabled = false`.
 */
export function useActionCableSubscription(
  params: Parameters<Subscriptions['create']>[0],
  handlers: Parameters<Subscriptions['create']>[1],
  options?: UseActionCableSubscriptionOptions,
) {
  const consumer = useActionCable();
  const paramsRef = useRef(params);
  const handlersRef = useRef(handlers);

  useEffect(() => {
    paramsRef.current = params;
    handlersRef.current = handlers;
  }, [params, handlers]);

  useEffect(() => {
    if (options?.isEnabled === false) {
      return undefined;
    }

    const subscription = consumer.subscriptions.create(paramsRef.current, handlersRef.current);
    console.log('[useActionCableSubscription] created subscription', subscription);
    console.log('[useActionCableSubscription] handlers', handlersRef.current);
    console.log('[useActionCableSubscription] params', paramsRef.current);

    return () => {
      subscription.unsubscribe();
    };
  }, [consumer, paramsRef, handlersRef, options?.isEnabled]);
}
